/* eslint-disable react/jsx-props-no-spreading */
import { Box, SxProps, Theme } from '@mui/material';
import React, { useCallback } from 'react';
import ETOButton from '../Button/ETOButton';
import { ETOButtonProps } from '../Button/ETOButtonProps';

type ModifiedButtonProps = Omit<ETOButtonProps & { text: string }, 'size'>;

export interface ButtonStripProps {
  className?: SxProps;
  buttonClassName?: SxProps;
  rightButton: ModifiedButtonProps;
  leftButton?: ModifiedButtonProps;
  size: 'small' | 'medium' | 'large';
}

const root: SxProps<Theme> = (theme: Theme) => ({
  borderTop: `2px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(2),
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

const renderedBtn: SxProps = {
  marginLeft: 'auto',
};

const ButtonStrip: React.FC<React.PropsWithChildren<ButtonStripProps>> = (props) => {
  const {
    rightButton, leftButton, size, className, buttonClassName,
  } = props;

  const _renderButton = useCallback((sz: 'small' | 'medium' | 'large', btn: ModifiedButtonProps, right?: boolean) => {
    const {
      color, text, tooltip, loading
    } = btn;

    return (
      <ETOButton
        customSx={[
          ...(Array.isArray(buttonClassName) ? buttonClassName : [buttonClassName]),
          { ...(right && renderedBtn) },
        ]}
        {...(btn)}
        color={color}
        size={sz}
        tooltip={tooltip}
        loading={loading}
      >
        {text}
      </ETOButton>
    );
  }, [buttonClassName]);

  return (
    <Box sx={[
      root,
      ...(Array.isArray(className) ? className : [className]),
    ]}
    >
      {
        leftButton && _renderButton(size, leftButton)
      }
      {
        rightButton && _renderButton(size, rightButton, true)
      }
    </Box>
  );
};

export default ButtonStrip;
